import { customInstance } from '@/common/infrastructure/http/apiClient';
import { mapVariablesCatalogDto } from '@/document-types/application/mappers/mapVariablesCatalogDto';
import type { DocumentTypeRef, DocumentTypeVariableCategory } from '@/document-types/domain/types/DocumentType';

/** Loads a document type's variable catalog. Shared by the editor hook and the PDF generator. */
export const fetchVariableCatalog = async (ref: DocumentTypeRef): Promise<DocumentTypeVariableCategory[]> => {
  const url = `/api/pdf-templates/v1/document-types/by-keys/${ref.applicationKey}/${ref.moduleKey}/${ref.documentTypeKey}/variables`;
  const raw = await customInstance<unknown>({ url, method: 'GET' });
  return mapVariablesCatalogDto(raw);
};
